import { getExamesPorCategoria } from 'data/requisicao';
import useIsMobile from 'hooks/useIsMobile';
import { useState } from 'react';
import { Badge, Button, Col, Row } from 'react-bootstrap';

// Função utilitária para quebrar um array em colunas de tamanho dinâmico
const fatiarEmColunas = (array, tamanhoColuna = 7) => {
  const colunas = [];
  for (let i = 0; i < array.length; i += tamanhoColuna) {
    colunas.push(array.slice(i, i + tamanhoColuna));
  }
  return colunas;
};

function SeletorExamesCheckbox({ onConfirmarExames, examesSelecionados = [] }) {
  const isMobile = useIsMobile();
  const [selecionados, setSelecionados] = useState(examesSelecionados);

  const categorias = getExamesPorCategoria().map((cat) => ({
    ...cat,
    items: [...cat.items].sort((a, b) => (a.ordem || 0) - (b.ordem || 0)),
  }));

  const handleToggleExame = (exame) => {
    setSelecionados((prev) => {
      const existe = prev.find((e) => e.nome === exame.nome);
      if (existe) {
        return prev.filter((e) => e.nome !== exame.nome);
      }
      return [...prev, exame];
    });
  };

  const handleConfirmar = () => {
    const selecionadosOrdenados = [...selecionados].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
    onConfirmarExames(selecionadosOrdenados);
    setSelecionados([]);
  };

  const handleLimpar = () => setSelecionados([]);

  const isExameSelecionado = (nomeExame) => selecionados.some((e) => e.nome === nomeExame);

  const renderCategorias = () => {
    return categorias.map((categoria) => {
      const isCardio = categoria.categoria.toLowerCase().includes('cardio');
      const itensPorColuna = isCardio ? 5 : 7; // 7 itens para Lab, 5 para Cardio

      const colunasExames = fatiarEmColunas(categoria.items, itensPorColuna);

      return (
        <div className="mb-0" key={categoria.categoria}>
          <div
            className="d-flex justify-content-between align-items-center mb-1 p-1"
            style={{ backgroundColor: '#e3f2fd', borderRadius: '4px' }}
          >
            <strong style={{ fontSize: '13px', color: '#000000' }}>{categoria.categoria}</strong>
            <Badge bg="primary" pill>
              {categoria.items.length}
            </Badge>
          </div>

          <Row className="g-0 m-0 px-1">
            {colunasExames.map((colunaItems, colIndex) => (
              <Col
                key={colIndex}
                style={
                  isMobile
                    ? { flex: '0 0 100%', maxWidth: '100%' }
                    : {
                        flex: isCardio ? '0 0 25%' : '0 0 20%',
                        maxWidth: isCardio ? '25%' : '20%',
                        paddingRight: '5px',
                      }
                }
              >
                {colunaItems.map((exame) => {
                  const checked = isExameSelecionado(exame.nome);
                  return (
                    <label
                      key={exame.nome}
                      title={exame.nome}
                      className="d-flex align-items-center mb-0"
                      style={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        lineHeight: '1',
                        minHeight: '14px',
                        marginBottom: '2px', // Espaçamento compacto entre as linhas
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() =>
                          handleToggleExame({
                            ...exame,
                            categoria: categoria.categoria,
                          })
                        }
                        style={{
                          marginRight: '6px',
                          cursor: 'pointer',
                          flexShrink: 0,
                          width: isMobile ? '16px' : '13px',
                          height: isMobile ? '16px' : '13px',
                        }}
                      />
                      <span
                        style={{
                          fontSize: isMobile ? '13px' : '10px',
                          fontWeight: '600',
                          color: '#000000',
                          whiteSpace: isMobile ? 'normal' : 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: 'block',
                        }}
                      >
                        {exame.nome}
                      </span>
                    </label>
                  );
                })}
              </Col>
            ))}
          </Row>
        </div>
      );
    });
  };

  return (
    <div className="p-2 border rounded bg-white">
      {renderCategorias()}

      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 pt-1 border-top mt-1">
        <Badge bg="success">{selecionados.length} selecionado(s)</Badge>
        <div className="d-flex flex-wrap gap-2 w-100 w-md-auto">
          <Button
            className="w-100 w-md-auto"
            variant="outline-secondary"
            size="sm"
            onClick={handleLimpar}
          >
            Limpar
          </Button>
          <Button
            className="w-100 w-md-auto"
            variant="success"
            size="sm"
            onClick={handleConfirmar}
            disabled={selecionados.length === 0}
          >
            ✓ Adicionar Exames ({selecionados.length})
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SeletorExamesCheckbox;
